(() => {
  const mobile = window.matchMedia('(max-width: 959px)');
  const sharedGestureParams = {
    touchStartPreventDefault: false,
    touchMoveStopPropagation: false
  };
  const carouselConfigs = {
    '.product__media-container.below-mobile.swiper': {
      ...sharedGestureParams,
      touchAngle: 42,
      threshold: 4
    },
    '[data-pilot-lifestyle-slider]': {
      ...sharedGestureParams,
      touchAngle: 20,
      threshold: 8
    }
  };

  const tuneCarousels = () => {
    if (!mobile.matches) return;

    Object.entries(carouselConfigs).forEach(([selector, gestureParams]) => {
      document.querySelectorAll(selector).forEach((carousel) => {
        const swiper = carousel.swiper;
        if (!swiper || swiper.destroyed) return;

        Object.assign(swiper.params, gestureParams);

        if (swiper.originalParams) {
          Object.assign(swiper.originalParams, gestureParams);
        }
      });
    });
  };

  const watchForCarousels = () => {
    let attempts = 0;

    const check = () => {
      tuneCarousels();
      attempts += 1;

      if (attempts < 180) {
        window.requestAnimationFrame(check);
      }
    };

    check();
  };

  watchForCarousels();
  document.addEventListener('shopify:section:load', watchForCarousels);
  mobile.addEventListener('change', watchForCarousels);
})();
